import { createEvent } from '@cobuildlab/react-simple-state';
/**
 * @property {string} ON_ORDER_REQUEST triggers when a user tries to get all their orders
 * @property {string} ON_ORDER_REQUEST_ERROR shows an error when there's an error fetching the orders info
 */

export const ON_ORDER_REQUEST = createEvent();
export const ON_ORDER_REQUEST_ERROR = createEvent();